import styled from "styled-components";

export const Container = styled.div`
  position: sticky;
  top: ${({ theme }) => theme.space.headerMinHeight};
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
`;

export const Group = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  justify-content: space-between;
  flex: 1;
  &:first-child {
    display: none;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    flex: unset;
    &:first-child {
      display: flex;
    }
  }
`;
